<template>
    <div class="seller-edit animated fadeIn">
        <form @submit.prevent="validate" class="needs-validation" novalidate>
            <b-card header-tag="header" footer-tag="footer" no-body>
                <div slot="header">
                    <i class="fa fa-building"></i> Empresas
                    <b-link :to="`/partners/sellers/`" class="btn mr-2 btn-sm btn-primary float-right">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                    </b-link>
                </div>
                <b-tabs pills card justified @input="onActivateTab">
                    <b-tab title="1. Empresa" active>
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Dados da empresa</h4>
                        <hr class="mb-3"/>
                        <seller-input v-model="seller" :action="action" />
                    </b-tab>
                    <b-tab title="2. Dados Bancários" :disabled="isSalesPersonEditing">
                        <template>
                            <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                            <h4>Configurações bancárias</h4>
                            <hr class="mb-3" />
                            <bank-account v-model="bankAccount" :action="action" />
                        </template>
                    </b-tab>
                    <b-tab title="3. Documentação" :disabled="isSalesPersonEditing">
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Documentação <a href="javascript:void(0);" class="btn btn-sm btn-primary" @click="showUploadModal = true"><i class="fa fa-plus"></i></a></h4>
                        <hr class="mb-5" />
                        <div class="form-row">
                            <div class="col-sm-12">
                                <b-table ref="table" show-empty :dark="false" :busy="tableLoading" :hover="false" :striped="true" :bordered="false" :small="false" :fixed="false" responsive :items="documents" :fields="tableFields">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="m-2 align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                    <template slot="fileName" slot-scope="data">
                                        <a :href="data.item.uriPath" target="_blank">{{data.item.fileName}}</a>
                                    </template>
                                    <template slot="actions" slot-scope="row">                                        
                                        <button class="btn mr-2 btn-md btn-info action-btn" @click.prevent="onCustomActionClick(row)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="4. Adquirencia" :disabled="isSalesPersonEditing">
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Adquirencia  <a href="javascript:void(0);" class="btn btn-sm btn-primary" @click="showAcquiringModal = true"><i class="fa fa-plus"></i></a></h4>
                        <div class="form-row">
                            <div class="col-sm-12">
                                <b-table ref="acquiringTable" show-empty :dark="false" :busy="tableLoading" :hover="false" :striped="true" :bordered="false" :small="false" :fixed="false" responsive :items="acquiring" :fields="acquiringFields">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="m-2 align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>                                    
                                    <template slot="actions" slot-scope="row">
                                        <button class="btn mr-2 btn-md btn-info action-btn" @click.prevent="onAcquirerUrlActionClick(row)">
                                            <i class="fa fa-code"></i>
                                        </button>
                                        <button class="btn mr-2 btn-md btn-info action-btn" @click.prevent="onAcquiringActionClick(row)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="5. Administrador">
                        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                        <h4>Dados de acesso</h4>
                        <hr class="mb-3"/>
                        <user-input v-model="user" :action="action" />                                          
                    </b-tab>
                </b-tabs>
                <div slot="footer" v-if="!isSalesPersonEditing">
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </div>
            </b-card>
        </form>
        <b-modal
          id="modal-upload"
          ref="modal"
          title="Adicionar documentos"
          @hidden="resetUploadModal"
          @ok="handleUploadOk"
          ok-title="Salvar"
          cancel-title="Cancelar"
          v-model="showUploadModal">
          <form ref="form">
            <div class="form-row">
              <div class="col-sm-12">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Tipo:</label>
                    <select :class="{'custom-select': true}" v-model="uploadModel.description">
                        <option v-for="(s, index) in uploadFileTypeList" :key="index" :value="s.id">
                            {{s.name}}
                        </option>
                    </select>
                </div>
              </div>
            </div>
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <file-upload :accept="'.pdf,.png,.jpg'" :url='uploadModel.url' :headers="uploadModel.headers" btnLabel="Selecione um arquivo" btnUploadingLabel="Enviando arquivos..." @change="onFileChange"></file-upload>
                    </div>
                </div>
            </div>
          </form>
        </b-modal>
        <b-modal
          id="modal-acquiring"
          ref="acquiringModal"
          title="Adquirencia"
          @hidden="resetAcquiringModal"
          @ok="handleAcquiringOk"
          ok-title="Salvar"
          cancel-title="Cancelar"
          v-model="showAcquiringModal">
          <div class="alert alert-danger" role="alert" v-show="acquiringModel.hasError">{{acquiringModel.errorMessage}}</div>
          <form ref="form">
            <div class="form-row">
              <div class="col-sm-12">
                <div class="form-group">
                    <label for="exampleFormControlSelect12">Adquirencia:</label>
                    <select :class="{'custom-select': true}" v-model="acquiringModel.acquirerId">
                        <option v-for="(s, index) in acquirersList" :key="index" :value="s.id">
                            {{s.name}}
                        </option>
                    </select>
                </div>
              </div>
            </div>
            <div class="form-row">
                <div class="col-sm-12">
                  <base-input type="text" label="MID" v-model="acquiringModel.merchantId" maxlength="255" />
                </div>
            </div>
            <div class="form-row">
                <div class="col-sm-12">
                    <base-input type="text" label="Client Id" v-model="acquiringModel.clientId" maxlength="255" />
                </div>
            </div>
            <div class="form-row">
                <div class="col-sm-12">
                    <base-input type="text" label="Token" v-model="acquiringModel.token" maxlength="255" />
                </div>
            </div> 
            <div class="form-row">
                <div class="col-sm-12">
                    <base-input type="text" label="Tef Merchant ID" v-model="acquiringModel.tefMerchantId" maxlength="50" />
                </div>
            </div>            
          </form>
        </b-modal>
        <b-modal
            id="modal-acquirer-url"
            ref="acquirerUrlmodal"
            title="Visualizar url adquirente"
            @hidden="resetAcquirerSettingsModal"
            ok-title="Fechar"
            :ok-only="true"
            v-model="showAcquirerSettingsModal"
            size="lg">
            <form ref="form">
            <div class="form-row">
                <div class="col-sm-12">
                <div class="form-group">
                    <label>Url de notificação</label>
                    <div>
                    <small>{{this.acquiringModel.endPoint}}</small>
                    </div>
                </div>
                </div>
            </div>
            </form>
        </b-modal>
    </div>
</template>
<script>
import sellerService from '../../../services/Customer/sellerService'
import editPage from '../../../mixins/editPage'
import config from '../../../config'
import _ from 'lodash'
import { getInstance } from '../../../auth/authWrapper'
import sellerInput from '../../../components/customers/sellerInput.vue'
import BankAccount from '../../../components/customers/bankAccount.vue'
import UserInput from '../../../components/customers/userInput.vue'
import { generate } from 'gerador-validador-cpf'
export default {
  components: { sellerInput, BankAccount, UserInput },
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            uploadModel: {
                description: 'CNH',
                fileName: '',
                uriPath: '',
                errorMessage: '',
                hasError: true,
                url: `${config.apiEndpoints.sellersUri}upload`,
                headers: {}
            },
            acquiringModel: {
                acquirerId: 'PAGSEGURO',
                merchantId: '',
                clientId: '',
                token: '',
                hasError: false,
                errorMessage: ''
            },      
            uploadFileTypeList: [
                {
                    id: 'CNH',
                    name: 'CNH'
                },
                {
                    id: 'Contrato Social',
                    name: 'Contrato Social'
                },
                {
                    id: 'Inscrição Estadual',
                    name: 'Inscrição Estadual'
                },
                {
                    id: 'CPF',
                    name: 'CPF'
                },
                {
                    id: 'RG',
                    name: 'RG'
                },
                {
                    id: 'Comprovante de Residência',
                    name: 'Comprovante de Residência'
                },
                {
                    id: 'Cartão CNPJ',
                    name: 'Cartão CNPJ'
                },
                {
                    id: 'Evidencia Bancária',
                    name: 'Evidencia Bancária'
                },
                {
                    id: 'Outros',
                    name: 'Outros'
                }
            ],
            acquirersList: [            
                {
                    id: 'PAGSEGURO',
                    name: 'PagSeguro'                    
                },
                {
                    id: 'ADIQ',
                    name: 'Adiq'
                },
                {
                    id: 'FISERV',
                    name: 'Fiserv'
                }
            ],
            showUploadModal: false,
            showAcquiringModal: false,
            showAcquirerSettingsModal: false,
            tableLoading: false,
            tableFields: [
                {key: 'fileName', label: 'Arquivo', sortable: false},
                {key: 'description', label: 'Descrição', sortable: false},
                {key: 'actions', label: ''}
            ],
            acquiringFields: [
                {key: 'acquirerId', label: 'Adquirencia', sortable: false},
                {key: 'merchantId', label: 'MID', sortable: false},
                {key: 'clientId', label: 'Client ID', sortable: false},
                {key: 'tefMerchantId', label: 'Tef Merchant ID', sortable: false},
                {key: 'endPoint', label: 'Url', sortable: false, thClass: 'd-none', tdClass: 'd-none'},                
                {key: 'actions', label: ''}
            ],
            seller: {
                name: '',
                socialName: '',
                documentNumber: '',
                identityDocument: null,
                gender: null,
                birthDate: null,
                owner: {
                    name: '',
                    documentNumber: '',
                    identityDocument: '',
                    email: '',
                    phone: {
                        areaCode: '',
                        number: ''
                    }    
                },
                cnae: null,
                mcc: null,
                phone: {
                    areaCode: '',
                    number: ''
                },
                email: '',
                status: null,
                id: '',
                type: 'F',
                salesPersonId: null,
                contractId: null,
                address: {
                    street: '',
                    number: '',
                    complement: '',
                    district: '',
                    state: '',
                    city: '',
                    zipCode: '',
                    type: ''
                }
            },  
            bankAccount: {
                owner: '',
                document: '',
                number: '',
                branchNumber: '',
                documentType: '',
                bankCode: null,
                type: null,
                pagBankEmail: '',
                customerId: '',
                status: 'ACTIVE'
            },
            user: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    areaCode: '',
                    number: ''
                },
                id: '',
                customerId: '',
                role: 'Seller',
                blocked: false
            },
            documents: [],
            acquiring: [],
        }
    },
    computed: {
        action() {
            return this.$route.name
        },        
        isSalesPersonEditing() {
            return this.action == 'edit_seller' && this.$auth.isSalesPerson
        }
    },
    created(){
        this.fetchData()
    },
    watch: {
        'seller.documentNumber': function(value) {        
            if(this.seller.type == 'F') {
                this.bankAccount.document = value
            }            
        },       
        'seller.name': function(value) {
            if(this.seller.type == 'F') {
                this.bankAccount.owner = this.seller.name
            }
        },
    },
    methods: {
        async fetchData() {
            const self = this            
            let authService = getInstance();
            let token = await authService.getTokenSilently();
            self.uploadModel.headers = {'Authorization': `Bearer ${token}`}            
            
            if(this.action == 'edit_seller') {
                self.showLoading()
                sellerService.findDetailed(this.id).then((response) =>{
                    // response.data.documentsData = {
                    //     pageIndex: 0,
                    //     pageCount: 1,
                    //     pageSize: 50,
                    //     tableCount: 0,
                    //     data: []
                    // }
                    self.seller = {
                        name: response.data.name,
                        socialName: response.data.socialName,
                        documentNumber: response.data.documentNumber,
                        identityDocument: response.data.identityDocument ? response.data.identityDocument : null,
                        gender: response.data.gender ? response.data.gender : null,
                        cnae: response.data.cnae,
                        mcc: response.data.mcc,
                        phone: {
                            areaCode: response.data.phone.areaCode,
                            number: response.data.phone.number
                        },
                        email: response.data.email,
                        status: response.data.status,
                        id: response.data.id,
                        type: response.data.type,
                        salesPersonId: response.data.salesPersonId,
                        contractId: response.data.contractId,
                        address: {
                            street: '',
                            number: '',
                            complement: '',
                            district: '',
                            state: '',
                            city: '',
                            zipCode: '',
                            type: ''
                        }
                    }
                    self.seller.owner = response.data.owner
                    self.seller.address = response.data.addresses != null && response.data.addresses.length > 0 ?
                        response.data.addresses[0] 
                        :
                        self.seller.address 
                    self.documents = response.data.documents
                    self.user = response.data.users[0]
                    self.bankAccount = response.data.bankAccount
                    self.acquiring = response.data.acquiring
                    if(self.bankAccount == null)
                    {
                        self.bankAccount = {
                            owner: '',
                            document: '',
                            number: '',
                            branchNumber: '',
                            documentType: '',
                            bankCode: null,
                            type: null,
                            pagBankEmail: '',
                            customerId: ''
                        }
                    }                    
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
            else {
                if(config.partnersConfiguration.sellers.fakeData) {
                    this.seller.documentNumber = generate();
                    this.seller.identityDocument = '123456789';
                    this.seller.gender = 'MALE';
                    this.seller.status = 'ACTIVE';
                    this.bankAccount.bankCode = '001';
                    this.bankAccount.branchNumber = '0001';
                    this.bankAccount.number = '123456789';
                    this.bankAccount.type = 'CHECKING';
                }                
            }

            
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    self.user.role = 'Seller'
                    let request = self.seller
                    request.bankAccount = self.$auth.isSalesPerson ? null : self.bankAccount
                    request.documents = self.documents
                    request.acquiring = self.acquiring
                    request.user = self.user
                    request.id = self.id
                    if(this.action == 'new_seller') {
                        sellerService.createSeller(request).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/partners/sellers'})
                        }, (error) => {
                            self.hasError = true
                            self.errorMessage = error.response.data.message
                            self.hideLoading()
                        })
                    }
                    else {                        
                        sellerService.updateSeller(request).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/partners/sellers'})
                        }, (error) => {
                            self.hasError = true
                            self.errorMessage = error.response.data.message
                            self.hideLoading()
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        },        
        onFileChange (file) {
            //this.image = file.url
            this.uploadModel.fileName = file.fileName
            this.uploadModel.uriPath = file.uriPath
        },
        clearZipCodeValue() {
            this.$refs.zipcode.clearValue()
        },
        resetUploadModal() {
            this.uploadModel.description = 'CNH'
            this.uploadModel.fileName = ''
            this.uploadModel.uriPath = ''
            this.uploadModel.hasError = false
            this.uploadModel.errorMessage = ''
        },
        handleUploadOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            this.uploadModel.errorMessage = ''
            this.uploadModel.hasError = false
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            const self = this
            this.documents.push({
                description: this.uploadModel.description,
                fileName: this.uploadModel.fileName,
                uriPath: this.uploadModel.uriPath,
                id: 0
            })
            self.$nextTick(() => {
                self.$refs.modal.hide()
            })
        },
        onCustomActionClick(row) {
            _.pullAt(this.documents, row.index)
            this.$refs.table.refresh()
        },
        onAcquiringActionClick(row) {
            _.pullAt(this.acquiring, row.index)
            this.$refs.acquiringTable.refresh()
        },
        onAcquirerUrlActionClick(row) {            
            this.acquiringModel.endPoint = row.item.endPoint
            this.showAcquirerSettingsModal = true
        },
        resetAcquiringModal() {
            this.acquiringModel.acquirerId = 'PAGSEGURO'
            this.acquiringModel.merchantId = ''
            this.acquiringModel.clientId = ''
            this.acquiringModel.token = ''
            this.acquiringModel.errorMessage = ''
            this.acquiringModel.tefMerchantId = ''
            this.acquiringModel.hasError = false
        },
        handleAcquiringOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            this.acquiringModel.errorMessage = ''
            this.acquiringModel.hasError = false
            // Trigger submit handler
            this.handleAcquiringSubmit()
        },
        handleAcquiringSubmit() {
            const self = this
            let selected = this.acquiring.find((value) => value.acquirerId == this.acquiringModel.acquirerId);
            if(selected != null && selected.acquirerId != '') {
                this.acquiringModel.errorMessage = 'Acquirencia já cadastrada'
                this.acquiringModel.hasError = true
            }
            else {                
                this.acquiring.push({
                    acquirerId: this.acquiringModel.acquirerId,
                    merchantId: this.acquiringModel.merchantId,
                    clientId: this.acquiringModel.clientId,
                    token: this.acquiringModel.token,
                    endPoint: '',
                    sellerId: this.seller.id,
                    id: 0,
                    tefMerchantId: this.acquiringModel.tefMerchantId
                })
                self.$nextTick(() => {
                    self.$refs.acquiringModal.hide()
                })
            }            
        },
        resetAcquirerSettingsModal() {
            this.acquiringModel.endPoint = ''
        },
        onActivateTab(tabIndex) {
            if(tabIndex != 1) {
                return;
            } 
            if(this.seller.type == "F") {
                this.bankAccount.document = this.seller.documentNumber;
                this.bankAccount.owner = this.seller.name;
            }
        }   
    }
}
</script>

